import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "mt-1" }
const _hoisted_3 = ["type", "name", "aria-describedby"]

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InputField',
  props: {
  field: { type: String, required: true },
  label: { type: String, required: true },
  type: { type: String },
},
  emits: ["change"],
  setup(__props, { emit }) {

const props = __props;





const getType = computed(() => {
    return props.type || 'text'
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", {
      for: props.field,
      class: "block text-sm font-medium text-gray-700"
    }, _toDisplayString(props.label), 9, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change', $event.target.value))),
        type: _unref(getType),
        name: props.field,
        class: "block w-full rounded-md border-gray-300 shadow-sm focus:border-teal-500 focus:ring-teal-500 sm:text-sm",
        "aria-describedby": `${props.field}-description`
      }, null, 40, _hoisted_3)
    ])
  ]))
}
}

})